import { render } from "./DTag.vue?vue&type=template&id=b97502cc&scoped=true"
import script from "./DTag.vue?vue&type=script&lang=js"
export * from "./DTag.vue?vue&type=script&lang=js"

import "./DTag.vue?vue&type=style&index=0&id=b97502cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97502cc"]])

export default __exports__